import moment from "moment-timezone";
import { TYPO } from "styles/Typo";
import { useInfiniteQuery } from "@tanstack/react-query";
import React, { useRef, useEffect } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import ReportThumb from "../../components/ReportThumb";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
const PAGE_SIZE = 10;

type DiscussItem = {
  id: string | number;
  created_at: string;
  title: string;
  url?: string;
  [key: string]: any;
};

const Card = React.memo(({ item, index }: { item: any; index: number }) => {
  const router = useRouter();
  return (
    <TrackedListItem
      itemData={{
        kind: "report",
        report_id: item?.id,
        rank: index + 1,
      }}
      href={`/discuss/${
        item?.url_slug ? `${item?.url_slug}-${item?.id}` : item?.id
      }`}
      data-gtm-id={`feed-all-research-list`}
      className="flex gap-4 cursor-pointer group items-start "
      // onClick={() => {
      //   router.push(
      //     `/discuss/${
      //       item?.url_slug ? `${item?.url_slug}-${item?.id}` : item?.id
      //     }`
      //   );
      // }}
    >
      <ReportThumb
        data={item}
        width={85}
        className=" rounded-[10px] shrink-0  w-[85px]"
        loading="lazy"
      />
      <div className="flex flex-col gap-2">
        <p className={`${TYPO.TYPO5_SB} text-gray80 group-hover:text-blue40`}>
          {item.title}
        </p>
        <p className={`${TYPO.TYPO7_RG} text-gray40`}>
          {moment(item.created_at).format("YYYY.M.D")}
        </p>
      </div>
    </TrackedListItem>
  );
});
Card.displayName = "Card";

const fetchAllDiscussList = async ({ pageParam }: { pageParam?: any }) => {
  let url = "/api/discuss/all";
  if (pageParam && pageParam.lastAgendaId && pageParam.lastAgendaAt) {
    url += `?lastAgendaId=${
      pageParam.lastAgendaId
    }&lastAgendaAt=${encodeURIComponent(pageParam.lastAgendaAt)}`;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error("데이터를 불러오지 못했습니다.");
  return await res.json();
};

function AllResearchList() {
  const { t } = useTranslation("main");
  const observerRef = useRef<HTMLDivElement>(null);
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, status } =
    useInfiniteQuery<DiscussItem[], Error>({
      queryKey: ["all-discuss-list"],
      queryFn: ({ pageParam = undefined }) =>
        fetchAllDiscussList({ pageParam }),
      getNextPageParam: (lastPage: DiscussItem[] | undefined) => {
        if (
          !lastPage ||
          !Array.isArray(lastPage) ||
          lastPage.length < PAGE_SIZE
        )
          return undefined;
        const lastItem = lastPage[lastPage.length - 1];
        return {
          lastAgendaId: lastItem.id,
          lastAgendaAt: lastItem.issue_at,
        };
      },
      initialPageParam: undefined,
    });

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });
    });
    if (observerRef.current) {
      observer.observe(observerRef.current);
    }
    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [fetchNextPage, hasNextPage]);

  const allItems = data?.pages ? data.pages.flat() : [];
  if (!allItems || allItems.length === 0) return null;
  return (
    <div className="pb-[90px] flex flex-col gap-9 px-5">
      <p className={`${TYPO.TYPO3_SB} text-gray90 text-center `}>
        {t("latestReports")}
      </p>
      <TrackedList
        listId="feed_latest_reports_list"
        totalCount={allItems.length}
      >
        <div className="py-2 flex flex-col gap-6">
          {allItems.map((item, index) => (
            <Card item={item} key={index} index={index} />
          ))}
          <div ref={observerRef}></div>
          {/* {rowVirtualizer.getVirtualItems().map((virtualRow: any) => {
            const isLoaderRow = virtualRow.index > allItems.length - 1;
            const item = allItems[virtualRow.index];
            return (
              <div
                key={virtualRow.index}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: `${virtualRow.size}px`,
                  transform: `translateY(${virtualRow.start}px)`,
                }}
              >
                {isLoaderRow ? (
                  hasNextPage ? (
                    "불러오는 중..."
                  ) : (
                    "마지막입니다."
                  )
                ) : (
                  <Card item={item} />
                )}
              </div>
            );
          })} */}
        </div>
      </TrackedList>
    </div>
  );
}

export default AllResearchList;
